export const CHECK_IN_ASSIGNEE_REQUIRED_MESSAGE = 'Add at least one on-site rep when check-in is required.';
//# sourceMappingURL=check-in-assignee-required-message.js.map